import SectionTitle from './SectionTitle';

export default function DataSafety() {
  return (
    <>
      <SectionTitle>DATA SAFETY</SectionTitle>
      <div className="px-4 pb-5 text-sm text-gray-600">
        Safety starts with understanding how developers collect and share your data...
      </div>
    </>
  );
}